import {
  transformPaymentMethodIntent,
  transformPaymentMethods,
} from '@/common/integrations/menhir/employee/payments/payments.dto';
import {
  IEmployeePaymentMethod,
  IMenhirEmployeePaymentMethodsEnvelope,
  IMenhirPaymentRequest,
  MenhirPaymentMethodSetupIntent,
} from '@/common/integrations/menhir/employee/payments/payments.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';
import { TMoney } from '@coverflex-tech/hypernova-utils';

export const getPaymentMethodIntent = () =>
  menhirClient
    .post<
      null,
      MenhirPaymentMethodSetupIntent
    >(MENHIR_ENDPOINTS.EMPLOYEE.PAYMENTS.METHODS.SETUP)
    .then((envelope) => transformPaymentMethodIntent(envelope));

export const getPaymentMethods = (): Promise<IEmployeePaymentMethod[]> =>
  menhirClient
    .get<
      null,
      IMenhirEmployeePaymentMethodsEnvelope
    >(MENHIR_ENDPOINTS.EMPLOYEE.PAYMENTS.METHODS.ROOT)
    .then((envelope) => transformPaymentMethods(envelope.payment_methods));

export const createPaymentIntent = ({
  paymentMethodId,
  amount,
}: {
  paymentMethodId: string;
  amount: TMoney;
}) =>
  menhirClient
    .post<
      null,
      { payment_request: IMenhirPaymentRequest }
    >(endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.PAYMENTS.METHODS.PAYMENT_REQUEST, paymentMethodId), amount)
    .then((envelope) => ({
      clientSecret:
        envelope.payment_request.provider_payment_data.client_secret,
    }));
